import React, { PureComponent } from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import {
  Form,
  Col,
  Container,
  Row,
  Card,
  CardBody,
  Badge,
} from 'reactstrap';
import {
  obtenerMisDerechos,
} from '../../redux/actions/studentSubjectsActions';
import {
  saveMiInscripcion,
} from '../../redux/actions/inscripcionExamenActions';
import Confirm from '../../shared/components/Confirm';
import {
  createErrorMessage,
  createSuccessMessage,
  createWarningMessage,
} from '../../helpers/notification';
import LoadingSpinner from '../../shared/components/LoadingSpinner';
import { dateTimeFormat } from '../../helpers/dateFormat';

class StudentExamInscriptionContainer extends PureComponent {
  static propTypes = {
    history: PropTypes.shape({}).isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      items: [],
    };
  }

  componentDidMount() {
    const { page, pageSize } = this.state;
    this.loadFormData(page, pageSize);
  }

  loadFormData = () => {
    this.setState({ loading: true });
    obtenerMisDerechos({
      onSuccess: (result) => {
        this.setState({
          loading: false,
          items: result.items,
        });
      },
      onError: () => {
        this.setState({ items: [], loading: false });
        createErrorMessage('Error al intentar cargar la lista de exámenes disponibles');
      },
    });
  }

  inscribirme = (examen) => {
    const { materia, inscripto } = examen;
    if (inscripto) return;
    Confirm({
      title: 'Inscripción a examen',
      question: `Estás seguro que deseas inscribirte al examen de "${materia}"?`,
      yesLabel: 'Si, Inscribirme',
      noLabel: 'No, Volver',
      onConfirm: () => {
        this.setState({ loading: true });

        const { examenId, studentId } = examen;
        const params = {
          examenId,
          id: 0,
          perfilAlumnoId: studentId,
          calificacion: 0,
        };

        saveMiInscripcion(params, {
          onSuccess: () => {
            createSuccessMessage('Inscripción realizada exitosamente');
            this.loadFormData();
          },
          onError: (error) => {
            this.setState({ loading: false });
            if (error.message) {
              createWarningMessage(error.message);
            } else {
              createErrorMessage('Error al intentar inscribirse al examen');
            }
          },
        });
      },
    });
  };

  onDataTableClearFilters = () => {
    const { pageSize } = this.state;
    this.loadFormData(1, pageSize, {});
  };

  onBack = () => {
    const { history } = this.props;
    history.push('/pages/student-exams');
  };

  getGridActions = (key) => {
    const actions = {
      actions: this.actions,
    };
    return actions[key];
  }

  getDate = date => new Date(date).toLocaleDateString('en-GB');

  getInstanciaColor = ({ value }) => {
    if (value === 1) {
      return 'info';
    }

    if (value === 0) {
      return 'success';
    }

    return 'danger';
  }

  getParametroColor = ({
    value,
    item: { pp, asis },
    parametro,
  }) => {
    if (value === 3 && parametro === 'PP' && pp) {
      return 'danger';
    }

    if (value === 3 && parametro === 'Asistencia' && asis) {
      return 'danger';
    }

    return 'primary';
  }

  render() {
    const {
      loading,
      items,
    } = this.state;

    if (loading) {
      return <LoadingSpinner />;
    }

    return (
      <Container>
        <Row>
          <Col md={12}>
            {
              loading && (<LoadingSpinner />)
            }
            {
              !loading && (
                <Card>
                  <CardBody>
                    <Form className="form">
                      <div>
                        <h3 className="page-title">Lista de mis ex&aacute;menes</h3>
                      </div>
                      <Container className="summary-container">
                        <Row dir="ltr">
                          {items.length && items.map(g => (
                            <Col sm={6} md={5} lg={4} xl={3} key={`subject_${g.id}_${g.examenId}`}>
                              <Card
                                onClick={() => this.inscribirme(g)}
                                className={`link-card ${g.inscripto ? 'disabled' : ''}`}
                              >
                                <CardBody
                                  className={`summary-card summary-card--${this.getInstanciaColor(g.instancia)}`}
                                >
                                  <div
                                    className="summary-card__body checklist-card"
                                    style={{
                                      display: 'flex', flexDirection: 'column', padding: '0',
                                    }}
                                  >
                                    <h3
                                      className="summary-card__title"
                                      style={{
                                        minHeight: '64px',
                                        fontSize: '20px',
                                        marginBottom: '10px',
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                      }}
                                    >
                                      <Badge
                                        style={{ fontSize: '70%' }}
                                        key={`badge-${g.examenId}`}
                                        color="primary"
                                      >
                                        # {g.examenId}
                                      </Badge>
                                      {` ${g.materia}`}
                                    </h3>
                                    <hr />
                                    <div
                                      className="summary-card__item"
                                      style={{ display: 'flex', justifyContent: 'space-between' }}
                                    >
                                      <span>{g.malla}</span>
                                      <span>{g.semestre}º Semestre</span>
                                    </div>
                                    <div
                                      className="summary-card__item"
                                      style={{ display: 'flex', justifyContent: 'space-between' }}
                                    >
                                      <span>
                                        Fecha
                                        {': '}
                                        <Badge
                                          style={{ fontSize: '70%' }}
                                          key={`badge-l-${g.examenId}`}
                                          color="primary"
                                        >
                                          {new Date(g.fechaExamen).toLocaleDateString('en-GB')}
                                        </Badge>
                                      </span>
                                      <span>
                                        L&iacute;mite
                                        {': '}
                                        <Badge
                                          style={{ fontSize: '70%' }}
                                          key={`badge-l-${g.examenId}`}
                                          color="danger"
                                        >
                                          {dateTimeFormat(g.fechaLimiteInscripcionExamen)}
                                        </Badge>
                                      </span>
                                    </div>
                                    <div
                                      className="summary-card__item"
                                      style={{ display: 'flex', justifyContent: 'space-between' }}
                                    >
                                      <span>{' '}</span>
                                      <span>
                                        Examen:{' '}
                                        <Badge
                                          key={`badge-${g.examenId}-${g.instancia.value}`}
                                          color={this.getInstanciaColor(g.instancia)}
                                        >
                                          {g.instancia.label}
                                        </Badge>
                                      </span>
                                    </div>
                                    <div
                                      className="summary-card__item"
                                      style={{ display: 'flex', justifyContent: 'space-between' }}
                                    >
                                      <span>
                                        Asistencia:{' '}
                                        <span>
                                          <Badge
                                            key={`badge-${g.examenId}-${g.porcentajeAsistencia}`}
                                            color={this.getParametroColor({ ...g.instancia, parametro: 'Asistencia' })}
                                            style={{ fontSize: '14px' }}
                                          >
                                            {' '}{g.porcentajeAsistencia}
                                          </Badge>
                                          %
                                        </span>
                                      </span>
                                      <span>
                                        <span>
                                          PP:{' '}
                                          <Badge
                                            key={`badge-${g.examenId}-${g.porcentajePP}`}
                                            color={this.getParametroColor({ ...g.instancia, parametro: 'PP' })}
                                            style={{ fontSize: '14px' }}
                                          >
                                            {' '}{g.porcentajePP}
                                          </Badge>
                                          %
                                        </span>
                                      </span>
                                    </div>
                                    <div
                                      className="summary-card__item"
                                      style={{ display: 'flex', justifyContent: 'space-between', fontSize: '16px' }}
                                    >
                                      <span>
                                        {
                                          `Inscripto Materia: ${this.getDate(g.fechaInscripcionMateria)}`
                                        }
                                      </span>
                                      <span className="info">
                                        {g.inscripto
                                          ? `Inscripto Examen: ${this.getDate(g.fechaInscripcion)}`
                                          : ''
                                        }
                                      </span>
                                    </div>
                                    {
                                      g.instancia.value === 3 ? (
                                        <div
                                          className="summary-card__item"
                                          style={{ display: 'flex', justifyContent: 'space-between', fontSize: '17px' }}
                                        >
                                          <Badge color="warning">{g.instancia.item.motivo}</Badge>
                                        </div>
                                      ) : null
                                    }

                                  </div>
                                </CardBody>
                              </Card>
                            </Col>
                          ))}
                          {!items.length && (
                            <Col xs={12}>
                              <h4 className="page-subhead">
                                No tienes ex&aacute;menes pendientes
                              </h4>
                            </Col>
                          )}
                        </Row>
                      </Container>
                    </Form>
                    <div className="card__title">
                      <button
                        type="submit"
                        className="btn btn-outline-secondary"
                        onClick={this.onBack}
                      >Cancelar - Volver
                      </button>
                    </div>
                  </CardBody>
                </Card>
              )
            }
          </Col>
        </Row>
      </Container>
    );
  }
}

export default withRouter(StudentExamInscriptionContainer);
